/**
 * @file 会员等级徽章封装，多场景使用
 * @description 根据 memberInfo 展示对应等级徽章（免费 / 标准 / 专业 / 高级 / 旗舰）
 */
import styles from './index.module.less';
import {createCx} from '@/utils/cx';
import {MemberLevelValue, type MemberLevel} from '@/services/commerce/type';
import type {MemberInfo} from '@/services/commerce/entities/benefit';

const cx = createCx(styles);

/** 会员等级 与 徽章样式 class 映射 */
const LEVEL_BADGE_CLASS: Record<MemberLevel, string> = {
    [MemberLevelValue.FREE]: 'badgeFree',
    [MemberLevelValue.STANDARD]: 'badgeStandard',
    [MemberLevelValue.PRO]: 'badgePro',
    [MemberLevelValue.PREMIUM]: 'badgePremium',
    [MemberLevelValue.FLAGSHIP]: 'badgeFlagship',
};

interface LevelBadgeProps {
    memberInfo: MemberInfo;
    className?: string;
}

const LevelBadge: React.FC<LevelBadgeProps> = ({memberInfo, className}) => {
    if (!memberInfo.levelName) {
        return null;
    }
    return (
        <span
            className={cx(
                'levelBadge',
                LEVEL_BADGE_CLASS[memberInfo.memberLevel] || 'badgeFree',
                className,
            )}
        >
            <span className={cx('text')}>{memberInfo.levelName}</span>
        </span>
    );
};

export default LevelBadge;
